import { DrawerStatusValues } from "@phn/utility/constants/app";
import { dispatchDrawerStatusEvent } from "@phn/utility/helper/events";
import * as router from "../../../../../shared/services/routing-manager";
import { RouteChangeCallbacks } from "./sequences/common";
import { registerOpenDoubleDrawerSequence } from "./sequences/register-open-double-drawer-sequence";
import { registerCloseDoubleDrawerSequence } from "./sequences/register-close-double-drawer-sequence";
import { registerBackToPreviousMenuSequence } from "./sequences/register-back-to-previous-menu-sequence";
import { registerForwardToNextMenuSequence } from "./sequences/register-forward-to-next-menu-sequence";
import { registerTransitionSequence } from "./sequences/register-transition-sequence";

export function registerDoubleDrawerAnimationsSequences(): void {
  const routeChangeCallbacks: RouteChangeCallbacks = {
    onSlideMainDrawerOutEnd: () => router.syncAnimation(),
  };

  registerOpenDoubleDrawerSequence({
    onAnimationStarts: () => {
      dispatchDrawerStatusEvent(DrawerStatusValues.startOpening);
    },
    onAnimationEnds: () => {
      dispatchDrawerStatusEvent(DrawerStatusValues.finishOpening);
    },
  });
  registerCloseDoubleDrawerSequence({
    onBackdropFadeOutEnd: () => {
      router.syncAnimation();
    },
    onAnimationStarts: () => {
      dispatchDrawerStatusEvent(DrawerStatusValues.startClosing);
    },
    onAnimationEnds: () => {
      dispatchDrawerStatusEvent(DrawerStatusValues.finishClosing);
    },
  });

  registerBackToPreviousMenuSequence(routeChangeCallbacks);
  registerForwardToNextMenuSequence(routeChangeCallbacks);
  registerTransitionSequence(routeChangeCallbacks);
  registerTransitionSequence(routeChangeCallbacks, "reverse");
}
